import { render, staticRenderFns } from "./Webshell.vue?vue&type=template&id=567ddd4f&"
import script from "./Webshell.vue?vue&type=script&lang=js&"
export * from "./Webshell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports